import React from "react";

import LogoFramer from "assets/teams/logo-framer.svg";
import LogoAtlassian from "assets/teams/logo-atlassian.svg";
import LogoShopify from "assets/teams/logo-shopify.svg";
import LogoGitHub from "assets/teams/logo-github.svg";
import LogoLaunchDarkly from "assets/teams/logo-launchdarkly.svg";
import LogoTailscale from "assets/teams/logo-tailscale.svg";

import styles from "./TeamsUsedBy.module.css";

const LOGOS = [LogoFramer, LogoAtlassian, LogoShopify, LogoGitHub, LogoLaunchDarkly, LogoTailscale];

const TeamsUsedBy: React.FC = () => {
  return (
    <div className={styles.container}>
      <p>Trusted by teams at</p>

      <ul>
        {LOGOS.map((Logo) => (
          <li key={LOGOS.indexOf(Logo)}>
            <Logo />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TeamsUsedBy;
